<div
  class="cb-button-group-container"
  [class.cb-required]="required()"
  [class.cb-error]="error()"
  [class.cb-full]="fullWidth()"
>
  @if (label() || info()) {
    <div class="cb-input-label">
      @if (label()) {
        <label>{{ label() }}</label>
      }
      @if (info() && info()!.length > 0) {
        <cb-icon
          [cbTooltip]="info()!"
          tooltipPosition="top"
          tooltipStyle="dark"
          name="cb-base-outline-help"
        ></cb-icon>
      }
    </div>
  }
  <div
    class="cb-button-group"
    [class.disabled]="disabled()"
    [class.full]="fullWidth()"
  >
    @for (option of options(); track $index) {
      <div
        (click)="setValue(option.value)"
        class="cb-button-group-options"
        [class.icon-only]="option.label === undefined"
        [class.selected]="checkIsSelected(option.value)"
      >
        @if (option.icon) {
          <cb-icon [name]="option.icon"></cb-icon>
        }
        @if (option.label) {
          <p>
            {{ translateOptions() ? (option.label | translate) : option.label }}
          </p>
        }
        @if (option.count) {
          <cb-chip
            [iconType]="'none'"
            label="{{ option.count }}"
            size="sm"
          ></cb-chip>
        }
      </div>
    }
  </div>
</div>
